const SIZES = {
  ticketID: {
    xs: 6,
    sm: 6,
    md: true,
    lg: true
  },
  issuedOn: {
    xs: 6,
    sm: 4,
    md: 5,
    lg: 5
  },
  amountDue: {
    xs: 6,
    sm: 4,
    md: 4,
    lg: 4
  },
  evidence: {
    xs: 7,
    sm: 3,
    md: 3,
    lg: 3
  }
}

export default SIZES
